import { useLocaleContext } from '../../client/contexts/LocaleContext';
import { LanguageSelect } from '../../components/ui';
import { APP_LANGUAGE_FILTER_OPTIONS } from '../../shared/languageOptions';

export default function LanguageSelector() {
  const { locale, setLocale } = useLocaleContext();

  return (
    <LanguageSelect
      value={locale}
      onChange={(value) => setLocale(value as 'de' | 'en' | 'all')}
      options={APP_LANGUAGE_FILTER_OPTIONS}
      aria-label="Filter by language"
    />
  );
}
